var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-content"},[_c('div',{staticClass:"chat-entry chat-entry-event text-secondary text-center"},[_c('span',{staticClass:"chat-time"},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.entry.time))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }